import { GET_PREVIOUS_CUSTOMER_CARS } from "../../Actions/ActionConstants";

function previousCustomerCarsReducer(state = null, action) {
    switch (action.type) {
        case GET_PREVIOUS_CUSTOMER_CARS:
            if (action.data) { return action.data; }
            else { return state }
        default:
            return state;
    }
}
export default previousCustomerCarsReducer